/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { Button } from "src/components/UI/Buttons/ButtonPrimitives";
import { SpinnerCircle } from "src/components/UI/Loading/Spinners/SpinnerCircle/SpinnerCircle";

interface ButtonWithLoadingProps {
  loading: boolean;
  children: React.ReactNode;
  handleClick: (e?: any) => void;
  width: string;
}

export const ButtonWithLoading = ({ loading, children, handleClick, width }: ButtonWithLoadingProps) => (
  <Button
    onClick={() => handleClick()}
    style={{ display: "flex", whiteSpace: "pre", width: `${width}`, marginLeft: "0px" }}
  >
    {loading ? <SpinnerCircle /> : children}
  </Button>
);
